import React from "react";
import { useTranslation } from "react-i18next";
import { TierContext } from "tiers/context";
import { Tip } from "view/tooltips";
export const ColorWells = ({ colors, value: selected, onColorSelected }) => {
    return React.createElement("div", null, colors.map((a) => React.createElement(Well, Object.assign({}, a, { key: a.value, onClick: () => onColorSelected(a.value), selected: a.value === selected }))));
};
const Well = (props) => {
    const { label, hex, value, onClick, selected } = props;
    const tiers = React.useContext(TierContext);
    const { t } = useTranslation();
    const allowed = tiers.allow(props);
    return React.createElement(Tip, { content: t(["props." + label], label) },
        React.createElement("div", { className: `color-well ${selected ? "selected" : ""}`, style: { backgroundColor: hex !== null && hex !== void 0 ? hex : value }, onClick: allowed ? onClick : () => tiers.popup("colorwell") }, tiers.badge(props, "fa-fw")));
};
